var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',[_c('app-breadcrumb',{attrs:{"items":_vm.items}}),_vm._v(" "),(_vm.tableShow)?_c('app-table-paginate',{key:_vm.reload,attrs:{"preview":'access-history/date-history/',"previewCustom":'acces_date',"routeDelete":"no","selection":"no","tableQuery":_vm.getList,"tableColumns":_vm.tableColumns,"limit":_vm.limit,"search":false}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28eaa270","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auditoria/accessDatehistory.vue
// module id = omOw
// module chunks = 6